export default __webpack_public_path__ + "static/media/1852.ba8eab77.png";